import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import { connect } from 'react-redux';
import { nextPage } from '../../functions/nextPage';
import * as routes from '../../../constants/routes';

export class ThankYouPfaAppointmentPage extends Component {
  constructor(props) {
    super(props);
    this.oldTitle = document.title;
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.history.push(routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE);
    }
    }

  render() {
    document.title = "Thank You For Requesting an Appointment | Cleveland Clinic";
    const title = "Thank you for choosing Cleveland Clinic.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--primary",
            value: 'Request another appointment',
            onClick: () => {
              document.title = this.oldTitle;
              this.props.history.push(nextPage());
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>

            <h3>What happens next:</h3>
            <p>A record of your pending appointment request has been emailed to you.</p>
            <p>After receiving financial clearance, your request will be sent to the appropriate department and a Cleveland Clinic representative will email you with the time and date of your appointment.</p>
            <p>To check on your financial clearance status, you can speak to an appointment specialist at <a href="tel:8663204573">866.320.4573</a>.</p>
            <h3>What you can do now:</h3>
            <p>In the meantime, you can find reliable answers to your medical questions at our <a href="/health">Health Library</a> or visit <a href="https://health.clevelandclinic.org">Health Essentials</a> for health and wellness advice or request another appointment.</p>
          </GridItem>
        </Grid>

        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

// connects component to redux, and passes along the router
export default withRouter(connect()(ThankYouPfaAppointmentPage));
